import { useState, useEffect } from "react";

/**
 * Hook que sincroniza el atributo data-bs-theme del <html>
 * con la preferencia del sistema operativo (prefers-color-scheme).
 */
const useTheme = () => {
  const [theme, setTheme] = useState(() => {
    if (window.matchMedia?.("(prefers-color-scheme: dark)").matches) {
      return "dark";
    }
    return "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      setTheme(e.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return { theme, isDark: theme === "dark" };
};

export default useTheme;
